import { connect } from 'react-redux'
import MapMenu from './MapMenu'

const mapStateToProps = (state, ownProps) => ({
	searchOpen: state.search.open
});

export default connect(mapStateToProps)(MapMenu);


// WEBPACK FOOTER //
// ./src/components/MapMenu/MapMenuContainer.js